module.exports = __webpack_public_path__ + "static/img/wxd01.a5cf1ed8.png";